'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Chip, DatePicker, DropdownMenu } from '@common/components';
import { useState } from 'react';
import { CHANNEL_LABEL, toOptions } from '../../_utils/labels';
import type { ReportFilter } from '../../_utils/report/report';
import { PERIODS, rangeOf, todayOf } from '../../_utils/report/report';
import type { Channel } from '../../_utils/types';
import { ChannelOptionIcon } from '../home/ChannelOptionIcon';
const CHANNEL_OPTIONS = [{
  label: '전체 채널',
  value: '' as const
}, ...toOptions(CHANNEL_LABEL).map(option => ({
  ...option,
  icon: <ChannelOptionIcon channel={option.value} />
}))];
interface ReportFilterBarProps {
  filter: ReportFilter;
  onApply: (filter: ReportFilter) => void;
  firstDate: string;
}
export const ReportFilterBar = t0 => {
  const $ = _c(49);
  const {
    filter,
    onApply,
    firstDate
  } = t0;
  let t1;
  if ($[0] !== filter.end || $[1] !== filter.isAll || $[2] !== filter.start) {
    t1 = {
      start: filter.start,
      end: filter.end,
      isAll: filter.isAll
    };
    $[0] = filter.end;
    $[1] = filter.isAll;
    $[2] = filter.start;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [draft, setDraft] = useState(t1);
  let t2;
  if ($[4] !== filter.end || $[5] !== filter.isAll || $[6] !== filter.start || $[7] !== firstDate) {
    t2 = PERIODS.find(period => {
      const range = rangeOf(period.key, firstDate);
      return range.isAll === filter.isAll && range.start === filter.start && range.end === filter.end;
    })?.key;
    $[4] = filter.end;
    $[5] = filter.isAll;
    $[6] = filter.start;
    $[7] = firstDate;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const selectedPeriod = t2;
  const today = todayOf();
  const isInvalid = draft.start === "" || draft.end === "" || draft.start > draft.end || draft.end > today;
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = next => {
      setDraft(current => ({
        ...current,
        ...next
      }));
    };
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleDraft = t3;
  let t4;
  if ($[10] !== filter || $[11] !== onApply) {
    t4 = channel => onApply({
      ...filter,
      channel
    });
    $[10] = filter;
    $[11] = onApply;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== filter.channel || $[14] !== t4) {
    t5 = <DropdownMenu dimensions="H40" options={CHANNEL_OPTIONS} value={filter.channel} onChange={t4} className="w-full" />;
    $[13] = filter.channel;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== filter || $[17] !== firstDate || $[18] !== onApply || $[19] !== selectedPeriod) {
    t6 = PERIODS.map(period_0 => <Chip key={period_0.key} className="shrink-0 whitespace-nowrap" checked={selectedPeriod === period_0.key} onCheckedChange={() => onApply({
      ...filter,
      ...rangeOf(period_0.key, firstDate)
    })}>{period_0.label}</Chip>);
    $[16] = filter;
    $[17] = firstDate;
    $[18] = onApply;
    $[19] = selectedPeriod;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t6) {
    t7 = <div className="flex shrink-0 gap-8 overflow-x-auto hide-scrollbar">{t6}</div>;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = start => handleDraft({
      start,
      isAll: false
    });
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== draft.end || $[25] !== draft.start) {
    t9 = <DatePicker dimensions="H40" value={draft.start} maxDate={draft.end} onChange={t8} className="min-w-0 flex-1" />;
    $[24] = draft.end;
    $[25] = draft.start;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span aria-hidden={true} className="text-Gray-400 typo-body4 max-xl:hidden">~</span>;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = end => handleDraft({
      end,
      isAll: false
    });
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== draft.end || $[30] !== draft.start) {
    t12 = <DatePicker dimensions="H40" value={draft.end} minDate={draft.start} maxDate={today} onChange={t11} className="min-w-0 flex-1" />;
    $[29] = draft.end;
    $[30] = draft.start;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== draft || $[33] !== filter || $[34] !== onApply) {
    t13 = () => onApply({
      ...filter,
      ...draft
    });
    $[32] = draft;
    $[33] = filter;
    $[34] = onApply;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== isInvalid || $[37] !== t13) {
    t14 = <div className="xl:shrink-0"><Button dimensions="H40" className="w-full" disabled={isInvalid} onClick={t13}>조회</Button></div>;
    $[36] = isInvalid;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== t12 || $[40] !== t14 || $[41] !== t9) {
    t15 = <div className="flex min-w-0 flex-col gap-8 xl:flex-1 xl:flex-row xl:items-center xl:gap-4">{t9}{t10}{t12}{t14}</div>;
    $[39] = t12;
    $[40] = t14;
    $[41] = t9;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== t15 || $[44] !== t7) {
    t16 = <div className="flex flex-col gap-12 xl:flex-row xl:items-center">{t7}{t15}</div>;
    $[43] = t15;
    $[44] = t7;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== t16 || $[47] !== t5) {
    t17 = <div className="flex flex-col gap-16">{t5}{t16}</div>;
    $[46] = t16;
    $[47] = t5;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  return t17;
};